// OEM App 定制 — 「已存在的应用组」mock
// 语义：应用组 = App管理（我的App）里的一个「应用」；其下为「版本 = 系统平台-上架区域 + AppID」
// 这里按企业维度提供该企业已存在的应用组，供「创建应用」时选择归属
// TODO: 联调时替换为 App管理列表接口（按企业过滤）

export const EXISTING_APP_GROUPS = {
    // test-SZ009 苏州智联门禁科技（OEM-1009 的定制企业）
    'test-SZ009': [
        {
            id: 'APP-9001', name: '智联门禁（标准版）', payMethod: 'enterprise', logo: '',
            versions: [{ platformLabel: 'Android', regionLabel: '国内', appId: 'com.hm.zlmj' }],
        },
        {
            id: 'APP-9002', name: '智联门禁（海外版）', payMethod: 'platform', logo: '',
            versions: [
                { platformLabel: 'Android', regionLabel: '海外', appId: 'com.hm.zlmj.os' },
                { platformLabel: 'iOS', regionLabel: '全球通用', appId: 'com.hm.zlmj.ios' },
            ],
        },
    ],
    // 以下为企业既有应用组示例（便于演示「加入已有应用组」）
    'test-JGSf0Nd7': [
        { id: 'APP-9101', name: '智联安防（旧版）', payMethod: 'enterprise', logo: '', versions: [{ platformLabel: 'Android', regionLabel: '国内', appId: 'com.hm.zlaf' }] },
    ],
    'test-SZ888': [
        { id: 'APP-9201', name: '云眸智能（旧版）', payMethod: 'platform', logo: '', versions: [{ platformLabel: 'iOS', regionLabel: '国内', appId: 'com.hm.ymzn' }] },
    ],
    'test-HZ999': [
        { id: 'APP-9301', name: '慧眼物联（旧版）', payMethod: 'enterprise', logo: '', versions: [{ platformLabel: 'Android', regionLabel: '国内', appId: 'com.hm.hywl' }] },
    ],
};

export const findAppGroup = (companyId, groupId) => (EXISTING_APP_GROUPS[companyId] || []).find((g) => g.id === groupId) || null;

// SearchSelect 用：按企业取应用组，支持按「应用名称 / AppID」模糊搜索
export const fetchAppGroups = (companyId) => (keyword = '') => {
    const list = EXISTING_APP_GROUPS[companyId] || [];
    const kw = String(keyword).trim().toLowerCase();
    const matched = kw
        ? list.filter((g) => g.name.toLowerCase().includes(kw)
            || (g.versions || []).some((v) => String(v.appId).toLowerCase().includes(kw)))
        : list;
    return Promise.resolve(matched.map((g) => ({ value: g.id, label: g.name })));
};
